import React from 'react'

import { StoreWithPersistor } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/cart-overview'

import { withCms, withLayout } from '../cms'
import { withCart } from '../components/hocs/with-cart'
import { getDeliveryIndicatorConfig } from '../configuration'

type Props = {
  store?: StoreWithPersistor
}

const CartOverview = (props: Props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return <Page store={props.store} delivery={{ indicatorConfig: deliveryIndicatorConfig }} />
}

export default compose<Props, Props>(
  withCms(),
  withLayout({ navigation: false }),
  withCart()
)(CartOverview)
